function Filters() {
	var self = this;
	this.xhr = undefined;
	this.init();
}

Filters.prototype.init = function() {
	var self = this;
	self.handleSelectFilters();
	self.handleLoadMore();
};

Filters.prototype.handleSelectFilters = function() {
	var self = this;

	$('body').on('click', '.news-filters-display-icons__icon', function(e) {
		e.preventDefault();
		if ($(this).is(":first-child"))
			$(this).closest('.news').find('.news-container').removeClass('news-container--list');
		else
			$(this).closest('.news').find('.news-container').addClass('news-container--list');
	});

	$('body').on('click', '.w-dropdown-toggle span', function(e) {
		$(this).closest('.w-dropdown').find('.w-dropdown-list a.dropdown-all-link').click();
	});

	$('body').on('click', '.w-dropdown-list a', function(e) {
		e.preventDefault();
		
		var that = this;
		var url = $(that).attr('href');
		var newTitle = $(that).text();

		if (typeof self.xhr !== 'undefined')
			self.xhr.abort();

		self.xhr = $.ajax({
			type: "POST",
			url: url,
			success: function(data) {
				var sort = $(data).find('.news-filters').html();
				$('.news-filters').html(sort).ajaxify();
				
				var projects = $(data).find('.news-container').html();

				$('.news-container').html(projects).ajaxify();
				// $('.news-container').find('.pagination').html($(data).find('.pagination').html());

				// app.handleLazyImages();
				app.waypoints = new Waypoints();
				app.handleFilterDropdowns();
				// app.filters.handleSelectFilters();

				window.history.pushState(url, null, url);
			}
		});
	});

	$('body').on('click', '.news-item__type', function(e) {
		var id = $(this).attr('data-id');
		$('.w-dropdown-list a[data-id="'+id+'"]').click();
	});
};

Filters.prototype.handleLoadMore = function() {
	var self = this;

	$('body').on('click', '.news-loadmore', function(e) {
		e.preventDefault();
		
		var that = this;
		var url = $(that).attr('href');
		var newTitle = $(that).text();

		if (typeof self.xhr !== 'undefined')
			self.xhr.abort();

		self.xhr = $.ajax({
			type: "POST",
			url: url,
			success: function(data) {
				var projects = $(data).find('.news-index > .f-row').html();

				// $('.news-index .paginate').find('.news-loadmore').parent().remove();
				$('.news-index > .f-row').append(projects).ajaxify();
				$('.news-index').find('.paginate').empty().html($(data).find('.paginate').html());

				// app.handleLazyImages();
				app.waypoints = new Waypoints();
				// app.handleFilterDropdowns();
				// app.filters.handleSelectFilters();

				window.history.pushState(url, null, url);
			}
		});
	});

};